import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    error: {},
};

const error = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.ADD_ERROR:
        return { ...state, error: action.payload };
    case APP_ACTIONS.ERRORS_LINE_ITEMS:
        return { ...state, errorLineItems: action.payload };
    case APP_ACTIONS.CLEAR_ERRORS_LINE_ITEMS:
        return { ...state, errorLineItems: [] };
    default:
        return state;
    }
};

export default error;



/** WEBPACK FOOTER **
 ** ./src/reducers/error.js
 **/